import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useOrders } from '../contexts/OrderContext';
import { Button } from '../components/ui/Button';
import { Input } from '../components/ui/Input';
import { Select } from '../components/ui/Select';
import { Card } from '../components/ui/Card';
import { ZONES } from '../constants/zones';
import { OrderType } from '../types';
import { ArrowLeft, CheckCircle } from 'lucide-react';
export function CreateOrderPage() {
  const navigate = useNavigate();
  const {
    createOrder
  } = useOrders();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [formData, setFormData] = useState({
    clientName: '',
    clientPhone: '',
    address: '',
    zone: '',
    type: 'TAPIS' as OrderType,
    quantity: 1,
    estimatedDeliveryDate: '',
    notes: ''
  });
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
    const {
      name,
      value
    } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };
  const handleFormSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    try {
      await createOrder({
        ...formData,
        clientId: `CL-${Math.floor(Math.random() * 10000)}`,
        quantity: Number(formData.quantity)
      });
      alert('Commande créée avec succès ! Elle est maintenant visible pour les chauffeurs.');
      navigate('/admin');
    } catch (error) {
      console.error('Failed to create order', error);
      alert('Erreur lors de la création de la commande');
    } finally {
      setIsSubmitting(false);
    }
  };
  return <div className="max-w-2xl mx-auto" data-id="element-348">
      <div className="flex items-center mb-6" data-id="element-349">
        <Button variant="ghost" onClick={() => navigate(-1)} className="mr-2" data-id="element-350">
          <ArrowLeft className="w-5 h-5" data-id="element-351" />
        </Button>
        <h1 className="text-2xl font-bold text-gray-900" data-id="element-352">
          Nouvelle Commande (Admin)
        </h1>
      </div>

      <Card data-id="element-353">
        <form onSubmit={handleFormSubmit} className="space-y-6" data-id="element-354">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-355">
            <Input label="Nom du client" name="clientName" value={formData.clientName} onChange={handleChange} required placeholder="ex: Mohamed Ali" data-id="element-356" />
            <Input label="Téléphone" name="clientPhone" value={formData.clientPhone} onChange={handleChange} required type="tel" placeholder="ex: 55 123 456" data-id="element-357" />
          </div>

          <Input label="Adresse complète" name="address" value={formData.address} onChange={handleChange} required placeholder="Rue, Immeuble, Appartement..." data-id="element-358" />

          <Select label="Zone" name="zone" value={formData.zone} onChange={handleChange} required options={ZONES.map(z => ({
          value: z,
          label: z
        }))} data-id="element-359" />

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-360">
            <div data-id="element-361">
              <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-362">
                Type d'article
              </label>
              <div className="flex space-x-4" data-id="element-363">
                <label className="flex items-center space-x-2 border rounded-lg p-3 flex-1 cursor-pointer hover:bg-gray-50" data-id="element-364">
                  <input type="radio" name="type" value="TAPIS" checked={formData.type === 'TAPIS'} onChange={handleChange} className="text-blue-600 focus:ring-blue-500" data-id="element-365" />
                  <span data-id="element-366">Tapis</span>
                </label>
                <label className="flex items-center space-x-2 border rounded-lg p-3 flex-1 cursor-pointer hover:bg-gray-50" data-id="element-367">
                  <input type="radio" name="type" value="HOUSSE" checked={formData.type === 'HOUSSE'} onChange={handleChange} className="text-blue-600 focus:ring-blue-500" data-id="element-368" />
                  <span data-id="element-369">Housse</span>
                </label>
              </div>
            </div>

            <Input label="Quantité" name="quantity" type="number" min="1" value={formData.quantity} onChange={handleChange} required data-id="element-370" />
          </div>

          <Input label="Date de livraison estimée" name="estimatedDeliveryDate" type="date" value={formData.estimatedDeliveryDate} onChange={handleChange} required data-id="element-371" />

          <div data-id="element-372">
            <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-373">
              Notes (Optionnel)
            </label>
            <textarea name="notes" value={formData.notes} onChange={handleChange} rows={3} className="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500" placeholder="Instructions spéciales..." data-id="element-374" />
          </div>

          <div className="pt-4" data-id="element-375">
            <Button type="submit" fullWidth size="lg" isLoading={isSubmitting} data-id="element-376">
              Créer la commande
            </Button>
          </div>
        </form>
      </Card>
    </div>;
}